export default {
  // Navigation
  prev: "Prev",
  next: "Next",
  home: "Home",
  suppliers: "Suppliers",
  company: "Kuwait Milk Company",
  about: "About",
  sections: "Selling Categories",
  milk: "Milk",
  article:
    "For more than 59 years, Kuwaiti dairy company has become synonymous with high quality dairy products, manufactured from fresh milk product daily from Kuwait's farms. Since its establishment in 1960, through the Kuwaiti Farmers Initiative, the Kuwait Dairy Initiative aims to establish an advanced production and distribution process mainly serving food security in Kuwait and achieves a qualitative leap in national potential. The Kuwaiti Dairy Company has successfully responsible and developed to become one of the largest and oldest industrial companies operating in the area of ​​Dairy, at the local level and the GCC.Kuwait Dairy manages various production lines on an area of ​​22 thousand square meters, a 550 tonnium productivity card, seeks to develop its production capacity up to 550 tons per day over the coming years. A sophisticated research team works on quality control and research to ensure that the product meets all health standards worldwide and works on this enormous production capacity, and business is continuously on the other. All these steps are carried out through a specialized laboratory and internationally established by Kuwait Dairy Company specifically for this purpose",
  products: "products",
  productName: "Milk",
  more: "More",
  OurShop: "Our Shop",
  Shop: "Supplier Products",
  Showing: "Showing",
  of: "Of",
  results: "Results",
  return_policy: "Return Policy",
  shipping_and_payment_terms: "Shipping and payment terms",
  supplierProducts:'Supplier Products',
  subject:'Subject',
  sendSupplierMessage:'Message Supplier',
  EstimatedPrice:'Estimated Price',
  by:'By',
  noDataAboutSellingCat:'No Selling Categories exits'
  
};
